import baseSavingActions from '../base-saving-actions/index';

const updateCleanUrlEnabled = (initial, current) =>
  initial !== current
    ? [baseSavingActions.setSiteMeta(['onlinestore', 'cleanUrlsEnabled'], current)]
    : [];

export default updateCleanUrlEnabled;
